import { MapPin, Truck } from "lucide-react";
import dayjs from "dayjs";
import { LoaderPinwheel } from "lucide-react";

const TimelineMovimientos = ({ movimientos = [], loading = false }) => {
  if (loading) {
    return (
      <div className="mb-4 flex items-center gap-2 rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 text-sm text-blue-700">
        <LoaderPinwheel className="h-4 w-4 animate-spin text-blue-600" />
        Cargando datos, por favor espera...
      </div>
    );
  }

  if (!movimientos.length) {
    return (
      <div className="text-center py-10 text-gray-400 text-sm">
        No hay movimientos registrados para este equipo
      </div>
    );
  }

  return (
    <ol className="relative border-l border-gray-200 ml-3 sm:ml-6">
      {movimientos.map((m) => {
        const isExterno = m.tipoMovimiento === "EXTERNO";

        return (
          <li key={m._id} className="mb-8 ml-6">
            {/* Icono */}
            <span
              className={`
                absolute -left-3 flex h-7 w-7 items-center justify-center rounded-full
                ${isExterno ? "bg-orange-500" : "bg-blue-600"} text-white
              `}
            >
              {isExterno ? <Truck size={15} /> : <MapPin size={15} />}
            </span>

            {/* Card */}
            <div
              className={`
                bg-white p-4 sm:p-5 rounded-xl shadow-sm border
                ${isExterno ? "airmail-border" : "border-gray-200"}
              `}
            >
              {/* Fecha */}
              <p className="text-xs text-gray-400 mb-1">
                {dayjs(m.createdAt).format("DD/MM/YYYY • HH:mm")}
              </p>

              {/* Movimiento */}
              <p className="font-semibold text-gray-800 text-sm sm:text-base">
                {m.tipoMovimiento === "INTERNO"
                  ? `${m.ubicacionActual?.interna?.sedeNombre} - ${m.ubicacionActual?.interna?.areaNombre} → ${m.ubicacionFinal?.interna?.sedeNombre} - ${m.ubicacionFinal?.interna?.areaNombre}`
                  : `${m.ubicacionActual?.interna?.sedeNombre} - ${m.ubicacionActual?.interna?.areaNombre || "Ubicación interna"} → Salida a ${m.ubicacionFinal?.externa?.destino}`}
              </p>

              {/* Detalles */}
              <div className="mt-2 space-y-1 text-sm text-gray-600">
                {m.responsableEquipo && (
                  <p>
                    <span className="font-medium">Responsable equipo:</span>{" "}
                    {m.responsableEquipo}
                  </p>
                )}

                {m.ubicacionFinal?.externa?.responsable && (
                  <p>
                    <span className="font-medium">Responsable externo:</span>{" "}
                    {m.ubicacionFinal.externa.responsable}
                  </p>
                )}

                {m.ubicacionFinal?.externa?.contacto && (
                  <p>
                    <span className="font-medium">Contacto:</span>{" "}
                    {m.ubicacionFinal.externa.contacto}
                  </p>
                )}

                {m.observacion && (
                  <p>
                    <span className="font-medium">Detalles:</span>{" "}
                    {m.observacion}
                  </p>
                )}
              </div>

              {/* Footer */}
              <p className="text-xs text-gray-400 mt-3">
                Registrado por {m.realizadoPor?.name}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default TimelineMovimientos;
